export const CHANGE_LABEL = {
    new: "New",
    worsened: "Worsened",
    improved: "Improved",
    resolved: "Resolved",
};
const getChangeType = (existed, now) => {
    if (existed === 0)
        return "new";
    if (now === 0)
        return "resolved";
    return now < existed ? "improved" : "worsened";
};
/** Merges the introduced and resolved sets into one row per issue id.
 *  now = report_issue_count (current total, identical on both sides);
 *  added = introduced-side files, fixed = resolved-side files;
 *  existed = now − added + fixed (referential total), omitted for New rows. */
export const mergeIssueChanges = (introduced, resolved) => {
    const byId = new Map();
    introduced.forEach((issue) => {
        byId.set(issue.id, {
            id: issue.id,
            description: issue.description,
            changeType: "new",
            now: issue.report_issue_count,
            existed: null,
            fixed: null,
            added: issue.diff_issue_count,
            hasIntroduced: true,
            hasResolved: false,
        });
    });
    resolved.forEach((issue) => {
        const existing = byId.get(issue.id);
        if (existing) {
            existing.hasResolved = true;
            existing.fixed = issue.diff_issue_count;
        }
        else {
            byId.set(issue.id, {
                id: issue.id,
                description: issue.description,
                changeType: "resolved",
                now: issue.report_issue_count,
                existed: null,
                fixed: issue.diff_issue_count,
                added: null,
                hasIntroduced: false,
                hasResolved: true,
            });
        }
    });
    return Array.from(byId.values()).map((row) => {
        var _a, _b;
        const existed = row.now - ((_a = row.added) !== null && _a !== void 0 ? _a : 0) + ((_b = row.fixed) !== null && _b !== void 0 ? _b : 0);
        const changeType = getChangeType(existed, row.now);
        return {
            ...row,
            changeType,
            existed: changeType === "new" ? null : existed,
        };
    });
};
export const filterIssueChanges = (rows, { search, changes }) => {
    const query = search.trim().toLowerCase();
    return rows.filter((row) => {
        if (changes.length > 0 && !changes.includes(row.changeType))
            return false;
        if (query.length > 0 &&
            !row.id.toLowerCase().includes(query) &&
            !row.description.toLowerCase().includes(query))
            return false;
        return true;
    });
};
const CHANGE_ORDER = {
    new: 0,
    worsened: 1,
    improved: 2,
    resolved: 3,
};
const PRIMARY_COMPARATOR = {
    change: (first, second) => CHANGE_ORDER[first.changeType] - CHANGE_ORDER[second.changeType],
    id: (first, second) => first.id.localeCompare(second.id),
    existed: (first, second) => { var _a, _b; return ((_a = first.existed) !== null && _a !== void 0 ? _a : 0) - ((_b = second.existed) !== null && _b !== void 0 ? _b : 0); },
    fixed: (first, second) => { var _a, _b; return ((_a = first.fixed) !== null && _a !== void 0 ? _a : 0) - ((_b = second.fixed) !== null && _b !== void 0 ? _b : 0); },
    added: (first, second) => { var _a, _b; return ((_a = first.added) !== null && _a !== void 0 ? _a : 0) - ((_b = second.added) !== null && _b !== void 0 ? _b : 0); },
    now: (first, second) => first.now - second.now,
};
/** Sorts by the active column; every column breaks ties by Now descending. */
export const sortIssueChanges = (rows, { property, reverse }) => {
    const direction = reverse ? -1 : 1;
    const primary = PRIMARY_COMPARATOR[property];
    return [...rows].sort((first, second) => {
        const comparison = primary(first, second) * direction;
        return comparison !== 0 ? comparison : second.now - first.now;
    });
};
//# sourceMappingURL=utils.js.map